import { NewReleasesOutlined, VerifiedOutlined } from '@mui/icons-material';
import React from 'react';
import { Row } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';
import styled from 'styled-components';

type Props = {
  verified: boolean;
  testingId?: string;
};

const Container = styled(Row)`
  align-items: center;
  div {
    margin-left: 4px;
    color: ${colors.dark};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`;

const BenchmarkReportStatusIndicator = ({ verified, testingId }: Props) => {
  return (
    <Container data-testid={testingId}>
      {verified ? (
        <>
          <VerifiedOutlined fontSize="small" sx={{ color: colors.mainGreen }} />
          <div>Verified</div>
        </>
      ) : (
        <>
          <NewReleasesOutlined
            fontSize="small"
            sx={{ color: colors.cautionDark }}
          />
          <div>Unverified</div>
        </>
      )}
    </Container>
  );
};

export default BenchmarkReportStatusIndicator;
